import {
	Id,
	LaravelResponse,
	ModelUsageResource,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import { TargetGroupIndexResource, TargetGroupSaveRequest, TargetGroupUpdateResource } from "../types/targetGroup";

const baseKey = ["target-groups"];

const showUsageKey = (targetGroupId: Id) => [...targetGroupService.showKey(targetGroupId), "usage"];

export const targetGroupService = {
	...withIndexEndpoint<TargetGroupIndexResource>(baseKey),
	...withShowEndpoint<TargetGroupUpdateResource>(baseKey),
	...withStoreEndpoint<TargetGroupSaveRequest>(baseKey),
	...withUpdateEndpoint<TargetGroupSaveRequest>(baseKey),
	...withDestroyEndpoint(baseKey),
	showUsageKey,
	showUsage: (targetGroupId: Id) =>
		axios.get<LaravelResponse<ModelUsageResource[]>>(keyToUrl(showUsageKey(targetGroupId))),
};
